import { httpClient } from "@utils";
import { LimitCategories as TWDELimitCategories } from "@api-types/myLimits/AvailableCategoriesTwde";
import { LimitCategories } from "@api-types";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";
import { getApiRequestContext } from "@utils/api-config";
import { getApplicationRequestHeaders } from "@utils/api-config/getApplicationRequestHeader";

export class GamingLimitCategoryApiService {
	static baseUrl(context: ApiRequestContextData): string {
		return `${WEBPACK_BASE_ADDRESS}${context?.agencyKey}/gaming-limit-categories`;
	}

	static getRequestHeaders = (context: ApiRequestContextData) => {
		const appHeaders = getApplicationRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	//TODO: switch params (activeaccount then category id), change also where this is used
	static getAvailableCategories(
		options: ContextOptions,
		categoryAbrv?: string | null
	): Promise<LimitCategories> {
		const context = getApiRequestContext(options);
		const params = new URLSearchParams();
		params.append("translate", "true");
		if (categoryAbrv) {
			params.append("categoryAbrv", categoryAbrv);
		}

		return httpClient.get(
			`${this.baseUrl(context)}/available-categories?${params.toString()}`,
			this.getRequestHeaders(context)
		);
	}

	static getAvailableCategoriesTWDESpecific(
		options: ContextOptions
	): Promise<TWDELimitCategories> {
		const context = getApiRequestContext(options);
		const params = new URLSearchParams();
		params.append("translate", "true");

		return httpClient.get(
			`${this.baseUrl(
				context
			)}/de/available-categories?${params.toString()}`,
			this.getRequestHeaders(context),
			{
				responseType: "json",
			}
		);
	}
}
